import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AllExamsLayer from "../components/AllExamsLayer";

const AllExamsPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="All Exams" />

        {/* AllExamsLayer */}
        <AllExamsLayer />
      </MasterLayout>
    </>
  );
};

export default AllExamsPage;
